import React from "react";

import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import InstagramIcon from "@material-ui/icons/Instagram";
import FacebookIcon from "@material-ui/icons/Facebook";

const ConnectionIcon = ({ connectionType, size = 16, className, style }) => {
    // Tamanho e padding dinâmicos para ficar menor sobre o avatar
    const pad = size <= 16 ? 1 : 2;
    const baseStyle = {
        padding: `${pad}px`,
        borderRadius: "50%",
        color: "#ffffff",
        fontSize: size,
        lineHeight: 1,
        display: "inline-flex",
        ...style,
    };

    if (connectionType === "whatsapp") {
        return (
            <WhatsAppIcon className={className} style={{ ...baseStyle, backgroundColor: "#25D366" }} />
        );
    }
    if (connectionType === "instagram") {
        return (
            <InstagramIcon className={className} style={{ ...baseStyle, backgroundColor: "#e1306c" }} />
        );
    }
    if (connectionType === "facebook") {
        return (
            <FacebookIcon className={className} style={{ ...baseStyle, backgroundColor: "#3b5998" }} />
        );
    }
    return null;
};

export default ConnectionIcon;
